export type PetState = 'idle' | 'waving' | 'jumping' | 'waiting' | 'review'

export function loadCreamCloudPet(): Promise<void> {
  if (typeof customElements !== 'undefined' && customElements.get('cream-cloud-pet')) return Promise.resolve()
  if (typeof document === 'undefined') return Promise.resolve()

  return new Promise((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>('script[data-pet-component]')
    if (existing) {
      existing.addEventListener('load', () => resolve(), { once: true })
      existing.addEventListener('error', () => reject(new Error('桌宠组件加载失败')), { once: true })
      return
    }
    const script = document.createElement('script')
    script.type = 'module'
    script.src = '/pet/cream-cloud-pet.js'
    script.dataset.petComponent = 'true'
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('桌宠组件加载失败'))
    document.head.appendChild(script)
  })
}
